import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './message.css';

const Message = ({
  flavor,
  ...props
}) => (
  <div
    className={cn('message-block', `message-${flavor}`)}
    {...props}
  />
);

Message.propTypes = {
  flavor: PropTypes.oneOf([
    'info',
    'info-lightning',
    'info-dark',
    'info-yellow',
    'security',
    'error'
  ])
};

Message.defaultProps = {
  flavor: 'info'
};

export default Message;



// WEBPACK FOOTER //
// ./src/widgets/Message/index.js